import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Button } from '@clutter/clean';

import { IAddressWithDetails } from '@shared/types/address';
import { IAddressValidationErrors } from '@shared/types/address_detail';

import { AddressForm } from '@portal/components/addresses/form';
import { useBuildAddressMutation } from '@portal/schema';

import { Error } from './form/error';
import { serialize } from './form/mutation';
import { DEFAULT_ADDRESS, DEFAULT_DETAILS, disabled, redirectToAccount, validate } from './utils';

const NewAddress: React.FC<{
  onCompleted(): void & RouteComponentProps;
}> = () => {
  const [address, setAddress] = React.useState<IAddressWithDetails>({ ...DEFAULT_ADDRESS, details: DEFAULT_DETAILS });
  const [execute] = useBuildAddressMutation({
    onCompleted: redirectToAccount,
  });
  const [errors, setErrors] = useState<IAddressValidationErrors | undefined>(undefined);
  const [submissionError, setSubmissionError] = useState<string | undefined>(undefined);

  React.useEffect(() => {
    if (address && !disabled(address)) {
      setSubmissionError(undefined);
    }
  }, [address]);

  const onFormSubmit = () => {
    if (disabled(address)) {
      setErrors(validate(address));
      setSubmissionError('Complete all required fields to save changes');
    } else {
      execute({ variables: { input: serialize(address) } });
    }
  };

  return (
    <React.Fragment>
      <AddressForm title="New Address" address={address} setAddress={setAddress} errors={errors} />
      {submissionError && <Error>{submissionError}</Error>}
      <Button onClick={onFormSubmit} kind="primary" type="button">
        Save Changes
      </Button>
    </React.Fragment>
  );
};

export { NewAddress };
